const Chart = require('chart.js')
const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		chartProperties: {
			type: 'bar',
			data: [],
			options: {
				legend: {
					display: true,
					position: 'bottom',
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				aspectRatio: 2,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				},
				tooltips: {
					callbacks: {
						label: (tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].label || ''}: ${utils.number.format(tooltipItem.yLabel, { prefix: '€ ', decimals: 2 }, 'float').formatted || ''}`,
					},
				},
			}
		},
	},

	model: {
		chartProperties: {}
	},

	methods: {
		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .canvasContainer > canvas'), this.model.chartProperties)
			}
		},

		update(){
			this.initChart()
			const data = this.resourceData.data || []
			const meta = this.resourceData.meta || []

			const actualYear = meta.actualYear || utils.moment().format('YYYY')

			if(this.model.chart && data){

				// TODO: TRANSLATIONS
				this.model.chart.data.labels = data.map(element => utils.moment(`${(element.attributes || {}).month}.${actualYear}`, 'MM.YYYY').format('MMMM'))
				this.model.chart.data.datasets[0] = {
					backgroundColor: '#AAAAAA',
					hoverBackgroundColor: '#666666',
					label: 'Durchschnitt exkl. Heuer',
					data: data.map(element => (element.attributes || {}).avg),
				}
				this.model.chart.data.datasets[1] = {
					backgroundColor: '#EFBA7D',
					hoverBackgroundColor: '#C27200',
					label: 'Letztes Jahr',
					data: data.map(element => (element.attributes || {}).lastYearSum),
				}
				this.model.chart.data.datasets[2] = {
					backgroundColor: '#90C190',
					hoverBackgroundColor: '#006E00',
					label: 'Heuer',
					data: data.map(element => (element.attributes || {}).actualYearSum),
				}

				this.model.chart.update()
			}
		},
	},

	hooks: {
		attach: function($element, options){
			// in case of refreshes the chart-dom-binding has to be renewed
			if (this.model.chart && (options || {}).refresh){
				this.model.chart.destroy()
				delete this.model.chart
			}
			if(!this.model.chart){
				this.model.chartProperties = this.config.chartProperties
				this.model.chartProperties.data = {}
				this.initChart()
			}

			this.update()
		},
	}
}
